import LatestArticles from './LatestArticles';

export default LatestArticles;
